import styled, { css } from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import {
  BORDER_RADIUS,
  SPACING,
} from "../../constants/design/spacing";
import { Button } from "../Buttons/styles";
import { fadeIn } from "../shared/style";

const contentPadding = css`
  padding: ${SPACING.three}px;
`;

export const HeaderContainer = styled.div`
  ${contentPadding}
  padding-bottom: ${SPACING.three}px;
  border-bottom: 1px solid ${BORDER_COLORS.two};
`;

export const InputContainer = styled.div`
  display: flex;

  ${Button} {
    aspect-ratio: 1;
    margin-left: ${SPACING.two}px;
  }
`;

export const MarketFilterContainer = styled.div`
  padding-top: ${SPACING.three}px;
  overflow-x: scroll;
`;

export const Section = styled.div<{ dragging?: boolean; dragOver?: boolean }>`
  padding-bottom: ${SPACING.three}px;
  margin-top: ${SPACING.three}px;

  opacity: 0;
  animation: ${fadeIn} 0.3s ease-in-out forwards;
  transition: opacity 0.2s ease, box-shadow 0.25s ease,
    transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  border-radius: ${BORDER_RADIUS.two}px;
  touch-action: pan-y;

  ${({ dragging }) =>
    dragging &&
    css`
      opacity: 0.95 !important;
      transform: scale(1.01);
      box-shadow: 0 14px 36px rgba(0, 0, 0, 0.55);
      z-index: 10;
      position: relative;
    `}

  ${({ dragOver }) =>
    dragOver &&
    css`
      transform: translateY(4px);
      box-shadow: 0 0 0 2px ${COLORS.highlight.one},
        0 6px 20px rgba(76, 215, 244, 0.16);
    `}
`;

/* Smooth accordion expand/collapse. Generous max-height so any realistic
   section animates fully without measuring its content. */
export const SectionContentWrapper = styled.div<{ collapsed?: boolean }>`
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 0.2s ease;
  max-height: ${({ collapsed }) => (collapsed ? "0" : "4000px")};
  opacity: ${({ collapsed }) => (collapsed ? 0 : 1)};
`;

export const Title = styled.div<{ noResults?: boolean }>`
  ${({ noResults }) => (noResults ? FONT_CSS.body.five : FONT_CSS.header.seven)}

  color: ${({ noResults }) => (noResults ? TEXT_COLORS.two : TEXT_COLORS.one)};
  padding: ${SPACING.two}px ${SPACING.three}px;
`;

export const SectionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: ${SPACING.three}px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: ${LAYER_COLORS.two};
  }
`;

export const ModalContentWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  height: 100%;
  min-height: ${({ isMobile }) =>
    isMobile ? `calc(100dvh - ${SPACING.three * 2}px)` : "70vh"};
  display: flex;
  flex-direction: column;
`;

export const CommandWrapper = styled.div`
  flex: 1;
  position: relative;
`;

export const CommandContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;

  > ${Section}:not(:last-child) {
    border-bottom: 1px solid ${BORDER_COLORS.two};
  }
`;
